import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, info?.componentStack);
  }
  handleReset = () => {
    this.setState({ error: null });
    window.location.assign('/login');
  };
  render() {
    if (this.state.error) {
      return (
        <div
          data-testid="app-error-boundary"
          className="min-h-screen flex items-center justify-center bg-background text-foreground p-6"
        >
          <div className="max-w-sm w-full border border-border bg-card p-8 space-y-4">
            <div className="velvet-eyebrow text-foreground/60">Velvet OS</div>
            <h2 className="font-serif text-2xl tracking-tight">Something unexpected happened.</h2>
            <p className="text-sm text-muted-foreground">
              {String(this.state.error?.message || this.state.error || 'Unknown error')}
            </p>
            <button
              onClick={this.handleReset}
              className="w-full rounded-sm bg-foreground text-background hover:bg-foreground/90 px-4 py-2 text-sm"
              data-testid="error-boundary-reset"
            >
              Reload sign in
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
